export const getNormalizedRoleNames = (user = {}) => {
  const fromRoles = Array.isArray(user?.roles)
    ? user.roles.map((role) => String(role?.name || '').toLowerCase())
    : []

  const fromRoleNames = Array.isArray(user?.roleNames)
    ? user.roleNames.map((name) => String(name || '').toLowerCase())
    : []

  const fromRoleNamesSnake = Array.isArray(user?.role_names)
    ? user.role_names.map((name) => String(name || '').toLowerCase())
    : []

  return [...new Set([...fromRoles, ...fromRoleNames, ...fromRoleNamesSnake])]
}

export const isAdministradorRole = (user = {}) => {
  return getNormalizedRoleNames(user).includes('admin')
}
